<script>
// @ts-check

import NoBankAccountErrorDialog from '@/components/NoBankAccountErrorDialog.vue'
import { mapGetters } from 'vuex'

const typeToRoute = {
  expense: 'new_expense',
  invoice: 'new_invoice',
  income: 'new_income',
  salary: 'edit_salary'
}

export default {
  name: 'CreateEntryButton',
  components: {
    NoBankAccountErrorDialog
  },
  props: {
    type: {
      type: String,
      required: true,
      /**
       * @param {string} value
       */
      validator: (value) =>
        ['expense', 'invoice', 'income', 'salary'].includes(value)
    },
    secondary: {
      type: Boolean
    }
  },
  data: () => ({
    noBankAccountErrorDialog: false,
    isNavigating: false
  }),
  computed: {
    ...mapGetters('app', ['isTlpService']),
    ...mapGetters('companyData', [
      'hasBankAccount',
      'isInDemoMode',
      'canCreateEntries'
    ]),
    label() {
      return this.$t(`entries.create_new_${this.type}`)
    },
    isBankAccountRequired() {
      // for TLP service the bank account is always required
      if (this.isTlpService) {
        return true
      }

      // for other services the bank account is required only for invoices
      return this.type === 'invoice'
    },
    isDisabled() {
      return !this.canCreateEntries
    }
  },
  methods: {
    async navigate() {
      if (this.isDisabled) {
        return
      }

      if (
        !this.isInDemoMode &&
        this.isBankAccountRequired &&
        !this.hasBankAccount
      ) {
        this.noBankAccountErrorDialog = true
        return
      }

      this.isNavigating = true

      await this.$router.push({ name: typeToRoute[this.type] })

      this.isNavigating = false
    }
  }
}
</script>

<template>
  <div>
    <component
      :is="secondary ? 'SecondaryButton' : 'PrimaryButton'"
      block
      :disabled="isDisabled"
      :loading="isNavigating"
      @click="navigate"
    >
      <slot>
        {{ label }}
      </slot>
    </component>

    <NoBankAccountErrorDialog
      v-if="noBankAccountErrorDialog"
      @cancel="noBankAccountErrorDialog = false"
    />
  </div>
</template>
